import React from 'react';
import { ChevronLeft } from 'lucide-react';
import { triggerUiHaptic } from '../utils/webHaptics';

export interface WebHeaderIconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    variant?: 'default' | 'white' | 'ghost';
    icon?: React.ReactNode;
    disableHaptics?: boolean;
}

export const WebHeaderIconButton: React.FC<WebHeaderIconButtonProps> = ({
    variant = 'default',
    icon,
    disableHaptics = false,
    onClick,
    className = '',
    children,
    'aria-label': ariaLabel = 'Go back',
    ...props
}) => {
    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        if (!disableHaptics) {
            triggerUiHaptic('selection');
        }
        onClick?.(e);
    };

    const variantStyles = {
        default: 'bg-slate-100 hover:bg-slate-200 text-slate-800',
        white: 'bg-white hover:bg-slate-50 text-slate-800 shadow-xs border border-slate-100/80',
        ghost: 'bg-transparent hover:bg-slate-100 text-slate-700',
    }[variant];

    return (
        <button
            type="button"
            onClick={handleClick}
            aria-label={ariaLabel}
            className={`w-[38px] h-[38px] rounded-full flex items-center justify-center shrink-0 transition-all duration-150 active:scale-95 select-none ${variantStyles} ${className}`}
            {...props}
        >
            {children || icon || <ChevronLeft className="w-5 h-5 stroke-[2.4]" />}
        </button>
    );
};

export default WebHeaderIconButton;
